<template>
  <div v-if="settings.bg_image" class="home">
    <site-header :dark="isIntersecting" :inverted="isMobile" flat />
    <div class="mobile-hero-wrapper" v-if="isMobile">
      <img :src="settings.bg_image" width="100%" class="mobile-hero-image" />
      <div class="mobile-hero-content">
        <hello-world
          v-if="header"
          is-mobile
          class="mt-6"
          :title="header.title"
          :subtitle="header.sub_title"
        />
        <home-filters v-intersect="onIntersect" />
      </div>
    </div>
    <div v-else ref="parallaxContainer" class="parallax-wrapper">
      <div
        class="parallax-bg"
        :style="{
          backgroundImage: `url(${bgImage})`,
          transform: `translateY(${parallaxOffset}px)`,
        }"
      />
      <div class="parallax-content">
        <span
          v-intersect="onIntersect"
          class="p-absolute"
          style="top: 20%"
          aria-hidden="true"
        />
        <v-card
          color="transparent"
          elevation="0"
          dark
          class="d-flex flex-column justify-center"
          style="height: 100%"
        >
          <hello-world
            v-if="header"
            class="mb-12"
            :title="header.title"
            :subtitle="header.sub_title"
          />
          <home-filters v-intersect="onIntersect" class="px-4 px-sm-12" />
        </v-card>
      </div>
    </div>
    <v-container>
      <site-listings
        :title="HOME_LISTINGS_TITLE"
        class="mb-8 mb-sm-16"
        lg="4"
        featured
      />
    </v-container>
    <home-top-destinations
      v-if="!!settings.destination_cities.length"
      :cities="settings.destination_cities"
    />
    <!-- <home-features /> -->
    <home-reviews />
    <!-- <home-trigger>
      <home-filters />
    </home-trigger> -->
    <v-divider />
    <site-footer />
    <!-- <site-bottom-navigation v-if="isMobile" /> -->
  </div>
</template>

<script>
import {
  BACKDROP,
  HOME_TITLE,
  HOME_SUBTITLE,
  HOME_LISTINGS_TITLE,
} from "@/consts/CMS";
import { mapActions, mapState } from "vuex";
import DeviceMixin from "@/mixins/device-mixin";
import MediaMixin from "@/mixins/media-mixin";
import SiteHeader from "@/components/header/site-header";
import HelloWorld from "@/components/home/hello-world";
import HomeFilters from "@/components/home/home-filters.vue";
import SiteListings from "@/components/common/site-listings.vue";
import HomeTopDestinations from "@/components/home/home-top-destinations";
// import HomeFeatures from "@/components/home/home-features";
import HomeReviews from "@/components/home/home-reviews.vue";
// import HomeTrigger from "@/components/home/home-trigger";
import SiteFooter from "@/components/footer/site-footer";
// import SiteBottomNavigation from "@/components/footer/site-bottom-navigation";

export default {
  name: "home-view",
  components: {
    SiteHeader,
    HelloWorld,
    HomeFilters,
    SiteListings,
    HomeTopDestinations,
    SiteFooter,
    HomeReviews,
    // HomeFeatures,
  },
  mixins: [DeviceMixin, MediaMixin],
  data: () => ({
    BACKDROP,
    HOME_TITLE,
    HOME_SUBTITLE,
    HOME_LISTINGS_TITLE,
    height: 0,
    isIntersecting: false,
    bottomMenuItem: "search",
    parallaxOffset: 0,
  }),
  computed: {
    screenHeight() {
      return window.innerHeight;
    },
    header() {
      return this.settings?.sections?.header;
    },
    ...mapState({
      settings: (state) => state.settingsModule.settings,
    }),
    bgImage() {
      return this.isMobile
        ? this.settings?.bg_image?.replace("upload/", "upload/c_fill,ar_1:2/")
        : this.resize(this.settings?.bg_image, this.screenHeight);
    },
  },
  methods: {
    ...mapActions("usersModule", ["getUsers"]),
    onIntersect(entries) {
      this.isIntersecting = entries[0].isIntersecting;
    },
    handleScroll() {
      if (this.$refs.parallaxContainer) {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        const containerTop = this.$refs.parallaxContainer.offsetTop;
        const containerHeight = this.$refs.parallaxContainer.offsetHeight;

        if (
          scrollTop >= containerTop &&
          scrollTop <= containerTop + containerHeight
        ) {
          this.parallaxOffset = (scrollTop - containerTop) * 0.5;
        }
      }
    },
  },
  mounted() {
    window.scrollTo({ top: 0 });
    this.getUsers();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.home {
  .mobile-hero-wrapper {
    position: relative;
    min-height: 100vh;
    height: auto;
    overflow: hidden;
    background-color: rgb(0, 0, 0);
    padding-bottom: 2rem;
  }

  .mobile-hero-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
  }

  .mobile-hero-content {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2rem 1.5rem;
  }

  .parallax-wrapper {
    position: relative;
    height: 100vh;
    overflow: hidden;
    background-color: rgb(0, 0, 0);
  }

  .parallax-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    filter: brightness(0.6);
    will-change: transform;
  }

  .parallax-content {
    position: relative;
    height: 100%;
    z-index: 1;
  }
}

.z-index-1 {
  position: relative;
  z-index: 1;
}
</style>
